import { AfterViewInit, Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { DocumentType } from '@domain/model/enums/document-type/document-type.enum';
import { AuthService } from '@modules/business-accounts/services/auth/auth.service';
import { ConfigContextService } from '@modules/business-accounts/services/config-context/config-context.service';
import { ParametersService } from '@modules/business-accounts/services/parameters/parameters.service';
import { TraceService } from '@modules/business-accounts/services/trace/trace.service';
import { RucValidator } from '@utils/helpers/validators.reniec';
import { environment } from 'environments/environment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AccountCreatedEvent } from '@modules/business-accounts/utils/interfaces/account-created-event.interface';
import { TraceError } from '@modules/business-accounts/utils/enums/trace-erros.enum';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, AfterViewInit {
  isAuthDone: boolean = false;
  authError: boolean = false;
  iframeUrl!: SafeResourceUrl;

  @Output() accountCreated = new EventEmitter<AccountCreatedEvent[]>();


  @ViewChild('iframeNewrelicRef') iframeNewrelicRef!: ElementRef<HTMLIFrameElement>;

  constructor(
    private readonly configContext: ConfigContextService,
    private readonly host: ElementRef<HTMLElement>,
    private readonly authService: AuthService,
    private readonly parametersService: ParametersService,
    private readonly traceService: TraceService,
    private readonly sanitizer: DomSanitizer
  ) {}

  ngAfterViewInit(): void {
    this.traceService.setFrameRef(this.iframeNewrelicRef.nativeElement);
  }

  ngOnInit(): void {
    const iframeUrl = `${environment.cdn}/${environment.iframeUrl}`;
    this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(iframeUrl);
    const element = this.host.nativeElement;
    const config: any = {
      companyDocumentNumber: this.readAttribute(element, 'company-document-number'),
      documentNumber: this.readAttribute(element, 'document-number'),
      sessionToken: this.readAttribute(element, 'session-token'),
      subscriptionKey: this.readAttribute(element, 'subscription-key'),
      triggerModel: this.readAttribute(element, 'trigger-model', false) || 'A',
      fullscreen: this.parseBooleanAttribute(this.readAttribute(element, 'fullscreen', false)),
      inline: this.parseBooleanAttribute(this.readAttribute(element, 'inline', false)),
    };
    // if (
    //   ((config.documentNumber as string).length !== 8 ||
    //   (config.companyDocumentNumber as string).length !== 11) ||
    //   ((config.companyDocumentNumber as string).slice(0, 2) !== '10' &&
    //   (config.companyDocumentNumber as string).slice(0, 2) !== '20')
    // ) {
    //   this.authError = true;
    //   return;
    // }
    const isRuc = RucValidator(config.documentNumber);
    config.documentType = isRuc ? 'RUC' : 'DNI';

    const isRucTen = isRuc && config.companyDocumentNumber.slice(0, 2) === '10';
    if (isRuc && isRucTen) {
      config.documentType = 'DNI';
    }

    const isRucTwenty = config.companyDocumentNumber.slice(0, 2) === '20';
    if (isRucTwenty) {
      config.documentType = 'RUC';
      config.legalRepresentant = config.documentNumber;
      config.documentNumber = config.companyDocumentNumber;
    }

    this.configContext.config = config;
    if (config.companyDocumentNumber != '' && config.documentNumber != '') {
      this.loadPopulateHeaders(config);
    } else
      this.isAuthDone = true;
  }

  parseBooleanAttribute(attribute: any) {
    if (typeof attribute === 'string') {
      return attribute === 'true' || attribute === '';
    }
    return false;
  }

  readAttribute(elem: HTMLElement, attrName: string, isRequired: boolean = true) {
    const attribute = elem.getAttribute(attrName);
    if (isRequired && attribute === null) throw new Error(`Attribute ${attrName} is required`);
    return attribute!;
  }

  loadPopulateHeaders(config: any) {
    this.authService
      .populateHeaders({
        sessionToken: config.sessionToken,
        subscriptionKey: config.subscriptionKey,
        documentType: DocumentType.DNI,
        documentNumber: config.legalRepresentant || config.documentNumber,
      })
      .subscribe({
        next: () => (this.isAuthDone = true),
        error: () => {
          this.authError = true;
          this.traceService.registerError(TraceError.AUTH_ERROR);
        },
      });

    this.parametersService.populateParameters();
  }
}
